import React from 'react';

const LogoAdminIcon = ({ className }: { className?: string }) => (
  <svg className={className} width="149" height="35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <g id="Layer_1">
        <g>
          <polygon
            fill="#cb2034"
            points="43.3 5.3 43.3 12.3 45.7 12.7 45.7 7.3 65.7 3.3 65.7 32.3 60.1 32.3 60.1 34.7 68.1 34.7 68.1 .3 43.3 5.3"
          />
          <path
            fill="#263d8e"
            d="M60.1,34.7h-23.2V11.3l23.2,3.6v19.8ZM39.4,32.3h18.4v-15.4l-18.4-2.8v18.2Z"
          />
          <path
            fill="#222"
            d="M83.7,14.1v-7.9h3v7.9c0,1.7-.5,3-1.4,3.9-.9.9-2.2,1.3-3.8,1.3s-2.9-.4-3.8-1.3c-1-.9-1.4-2.1-1.4-3.7V6.1h3v8c0,1.6.8,2.4,2.3,2.4s2.3-.8,2.3-2.5Z"
          />
          <path
            fill="#222"
            d="M93.3,8.6c-.5,0-.9.1-1.1.3s-.4.5-.4.8.2.6.5.9c.3.2.7.5,1.3.7s.9.4,1.2.5.6.3.9.6.6.5.8.7c.5.6.7,1.4.7,2.2s-.4,2.1-1.3,2.8c-.9.7-2,1.1-3.5,1.1s-2.7-.3-3.6-.8v-3c1.2.8,2.4,1.3,3.7,1.3s.8-.1,1.1-.4c.3-.2.4-.5.4-.9s0-.5-.2-.6c-.1-.1-.3-.2-.4-.3,0,0-.2-.2-.4-.2-.2,0-.3-.2-.5-.2-.4-.2-.8-.4-1.2-.5-.8-.4-1.5-.9-2-1.4-.5-.6-.8-1.4-.8-2.4s.4-1.9,1.2-2.6c.8-.7,1.9-1,3.3-1s2.5.2,3.5.7v2.8c-1-.6-2.1-.9-3.2-.9Z"
          />
          <path
            fill="#222"
            d="M79.2,30.2v4.5h-3v-12.9h4.5c1.4,0,2.6.4,3.5,1.2s1.3,1.8,1.3,3c0,1.8-.8,3.1-2.4,3.8l3.3,5h-3.5l-2.8-4.5h-.9ZM79.2,24.2v3.6h1.4c1.3,0,1.9-.6,1.9-1.9s-.2-1-.5-1.3c-.3-.3-.8-.5-1.4-.5h-1.5Z"
          />
          <path fill="#222" d="M91,32.3h5.1v2.4h-8v-12.9h8v2.4h-5v2.9h4.4v2.3h-4.4v2.9Z" />
          <path
            fill="#222"
            d="M98.1,34.7l1.1-12.9h3.2c1.5,4,2.4,6.3,2.6,6.9s.4,1.1.5,1.7c.2-.8.7-2.1,1.3-3.9l1.8-4.7h3.2l1.3,12.9h-3l-.5-5-.2-3.8c-.3.8-1.3,3.7-3.2,8.7h-1.7c-1.8-4.8-2.8-7.6-3-8.7,0,.9,0,2.2-.2,3.8l-.4,5h-3Z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default LogoAdminIcon;
